import React, { useState } from 'react';
import { Phone, Menu, X, InstagramIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const {
    t,
    language,
    toggleLanguage
  } = useLanguage();
  const navLinks = [{
    label: t('header.services'),
    href: '#servicios'
  }, {
    label: t('header.protocol'),
    href: '#protocolo'
  }, {
    label: t('header.about'),
    href: '#kate'
  }, {
    label: t('header.reviews'),
    href: '#resenas'
  }, {
    label: t('header.faq'),
    href: '#faq'
  }, {
    label: t('header.giftCard'),
    href: '#gift-card'
  }, {
    label: t('header.contact'),
    href: '#agenda'
  }];
  return <header className="sticky top-0 z-50 w-full bg-brand-dark backdrop-blur-md border-b border-brand-gold/10 md:border-brand-gold/15 shadow-sm md:shadow-lg" data-id="element-250" data-mp="3baobimytgzyz">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-251" data-mp="3f9ngu8ogmyqy">
        <div className="flex justify-between items-center h-16 md:h-20" data-id="element-252" data-mp="2wlm9fgegq8ky">
          {/* Logo Image */}
          <a href="#" className="flex-shrink-0" data-id="element-253" data-mp="2rkylx4pg09vh">
            <img src="https://cdn.magicpatterns.com/uploads/d5PCZLxog3stu5Kmdcos9m/tairu_new_1.png" alt="Tairu Aesthetics" className="h-14 w-auto object-contain mix-blend-lighten" data-id="element-254" data-mp="2mmopkqrzf38a" />
          </a>

          {/* Contact & CTA */}
          <div className="flex items-center space-x-4" data-id="element-255" data-mp="3fd6odfloaifw">
            <button onClick={toggleLanguage} className="text-xs font-bold tracking-widest text-gray-400 hover:text-brand-gold-light transition-colors flex items-center gap-1" aria-label="Toggle Language" data-id="element-256" data-mp="3adampn0g733i">
              <span className={language === 'es' ? 'text-brand-gold' : ''} data-id="element-257" data-mp="1w5zazhdk3r4">
                ES
              </span>
              <span className="opacity-50" data-id="element-258" data-mp="3talhovf1rad5">|</span>
              <span className={language === 'en' ? 'text-brand-gold' : ''} data-id="element-259" data-mp="3t9sge9yuxd2e">
                EN
              </span>
            </button>
            <a href="https://www.instagram.com/tairu.aesthetics/" target="_blank" rel="noopener noreferrer" className="flex lg:hidden items-center text-gray-300 hover:text-brand-gold-light transition-colors" aria-label="Instagram" data-id="element-260" data-mp="1wcegg7aj74ym">
              <InstagramIcon className="w-5 h-5" data-id="element-261" data-mp="18mtvxjyqbzn8" />
            </a>
            <a href="tel:5513328938" className="hidden md:flex items-center text-gray-300 hover:text-brand-gold-light transition-colors font-medium text-sm" data-id="element-262" data-mp="1coowuncr0b0h">
              <Phone className="w-4 h-4 mr-2" data-id="element-263" data-mp="13nz3rrevgyqg" />
              (551) 332-8938
            </a>
            <a href="https://book.heygoldie.com/tairu-aesthetics" target="_blank" rel="noopener noreferrer" className="hidden sm:inline-flex bg-brand-gold hover:bg-brand-gold-light text-white px-6 py-2.5 rounded-sm font-medium transition-colors duration-300 shadow-sm text-sm" data-id="element-264" data-mp="13ptp36u22sv2">
              {t('header.bookNow')}
            </a>

            {/* Instagram (desktop, next to the hamburger) */}
            <a href="https://www.instagram.com/tairu.aesthetics/" target="_blank" rel="noopener noreferrer" className="hidden lg:flex items-center text-gray-300 hover:text-brand-gold-light transition-colors" aria-label="Instagram" data-id="element-265" data-mp="w59ad9cghecs">
              <InstagramIcon className="w-5 h-5" data-id="element-266" data-mp="105tb0mw8n03o" />
            </a>

            {/* Menu button */}
            <button onClick={() => setMobileOpen(!mobileOpen)} className="p-2 text-gray-300 hover:text-brand-gold-light transition-colors" aria-label="Abrir menú" aria-expanded={mobileOpen} data-id="element-267" data-mp="1f2kasx9tqdtt">
              {mobileOpen ? <X className="w-6 h-6" data-id="element-268" data-mp="3bx6rgbpu2jtd" /> : <Menu className="w-6 h-6" data-id="element-269" data-mp="22zgli461wmng" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav Dropdown */}
      {mobileOpen && <div className="bg-brand-dark border-t border-brand-gold/10 shadow-lg lg:absolute lg:right-8 lg:top-full lg:w-80 lg:border lg:border-brand-gold/20 lg:rounded-sm lg:shadow-2xl lg:mt-2" data-id="element-270" data-mp="2cx4hexfe8077">
          <nav className="max-w-7xl mx-auto px-4 py-4 space-y-1" data-id="element-271" data-mp="1k85zo1f6n02f">
            {navLinks.map(link => <a key={link.href} href={link.href} onClick={() => setMobileOpen(false)} className="block py-3 px-4 text-gray-300 hover:text-brand-gold-light hover:bg-white/5 rounded-sm transition-colors font-medium text-sm" data-id="element-272" data-mp="1p70q9pje5sx3">
                {link.label}
              </a>)}
            <div className="pt-3 border-t border-brand-gold/10 mt-2" data-id="element-273" data-mp="11hfx6dtixfa3">
              <a href="tel:5513328938" className="flex items-center py-3 px-4 text-gray-300 font-medium text-sm" data-id="element-274" data-mp="15hyp07vf2lca">
                <Phone className="w-4 h-4 mr-2" data-id="element-275" data-mp="t0xceogtfe3q" />
                (551) 332-8938
              </a>
              <a href="https://book.heygoldie.com/tairu-aesthetics" target="_blank" rel="noopener noreferrer" onClick={() => setMobileOpen(false)} className="block mt-2 text-center bg-brand-gold text-white py-3 rounded-sm font-medium" data-id="element-276" data-mp="oytxtqyunte8">
                {t('header.bookNow')}
              </a>
            </div>
          </nav>
        </div>}
    </header>;
}